import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import TextInput from '../../../../components/ui/TextInput/TextInput'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`

const StyledButton = styled(ActionButton)`
  width: 100%;
`

function AccountRecoveryForm(props) {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
  } = props

  return (
    <form
      onSubmit={handleSubmit}
      method={method}
      action={action}
      autoComplete="off"
    >
      <fieldset disabled={isSubmitting || disabled}>
        <TextInput
          name="accountIdentifier"
          type="text"
          placeholder="Email Address"
          initialValue={values.accountIdentifier}
          error={errors.accountIdentifier}
          touched={touched.accountIdentifier}
          onChange={handleChange}
          onBlur={handleBlur}
          floatingLabel={false}
          centered
        />
        <ButtonWrapper>
          <StyledButton type="submit" variant="primary" disabled={!isValid}>
            Continue
          </StyledButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

AccountRecoveryForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

AccountRecoveryForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default AccountRecoveryForm
